import { useTranslation } from 'react-i18next'
import { formatDateTimeLocalized } from '@/utils/date'

interface Props {
  uploadedAt?: string | null
  processedAt?: string | null
}

/** Document times shared by the confirmed-face and full-photo tiles. */
export function DocumentTimestampDetails({ uploadedAt, processedAt }: Props) {
  const { t, i18n } = useTranslation()
  if (!uploadedAt && !processedAt) return null

  return (
    <span className="flex flex-col gap-0.5 text-2xs text-muted-foreground">
      {uploadedAt && (
        <span>
          {t('documents.detail.uploaded')}: {formatDateTimeLocalized(uploadedAt, i18n.language)}
        </span>
      )}
      {processedAt && (
        <span>
          {t('documents.detail.processed')}: {formatDateTimeLocalized(processedAt, i18n.language)}
        </span>
      )}
    </span>
  )
}
